module.exports = "/_next/static/images/4c359fca171a1b06c36221a529b96fe5-roxinho-basicos-flutuantes-xs@3x.png";